export default {
    'user_avatar': 0,
    'avatar': 0,
    'logo_image': 1,
    'cover_picture_image': 2,
    'cover_image': 2
};